export const STORED_ERRORS = "STORED_ERRORS";